import React from 'react';
import {Routes, Route} from 'react-router-dom';
import TopMenu from "../components/TopMenu";
import LeftMenu from "../components/LeftMenu";
import routes from "../routesConfig";
import Concerts from "./admin/concert/Concerts";
import Users from "./admin/user/Users";
import GeneralSettings from "./admin/generalSettings/GeneralSettings";
import LyricsCategories from "./admin/lyricsCategory/LyricsCategories";
import Lyrics from "./admin/lyrics/Lyrics";
import DiscographyAlbums from "./admin/discographyAlbum/DiscographyAlbums";
import Blog from "./admin/blog/Blog";
import DiscographyItems from "./admin/discographyAlbum/DiscographyItems";

import "./Admin.css";

const Admin = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <TopMenu className="flex-shrink-0"/>
            <div className="flex flex-grow overflow-hidden">
                <LeftMenu className="flex-shrink-0 w-64 bg-gray-800 text-white"/>
                <div className="flex-1 min-w-0 min-h-0 p-4 overflow-scroll">
                    <Routes>
                        <Route path={routes.admin.concert} element={<Concerts/>}/>
                        <Route path={routes.admin.user} element={<Users/>}/>
                        <Route path={routes.admin.generalSettings} element={<GeneralSettings/>}/>
                        <Route path={routes.admin.lyricsCategories} element={<LyricsCategories/>}/>
                        <Route path={routes.admin.lyricsListItems} element={<Lyrics/>}/>
                        <Route path={routes.admin.blog} element={<Blog/>}/>
                        <Route path={routes.admin.discographyAlbums} element={<DiscographyAlbums/>}/>
                        <Route path={routes.admin.discographyItems} element={<DiscographyItems/>}/>

                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default Admin;
